<template>
    <section class="corp-hero">

        <div class="corp-hero__container">

            <div class="corp-hero__content">

                <h1>
                    {{ contentKey | staticTitle }}
                </h1>

                <vue-marked>
                    {{ contentKey | staticContent }}
                </vue-marked>

            </div>

            <slot name="default"></slot>

        </div>

    </section>
</template>

<script>
export default {
    name: 'LandingCoreHero',

    props: {
        contentKey: {
            type: String,
            default: 'landing'
        }
    }
};
</script>

<style lang="scss" scoped>
.corp-hero {

    &__container {
        gap: 8px;
    }

    &__gallery {
        @media screen and (max-width: 1100px) {
            display: none;
        }
    }

    @media (max-width: 1100px) {

        &__container {
            gap: 12px;
        }

    }

    @media (max-width: 768px) {

        &__container {
            gap: 16px;
        }

    }

}
</style>